import { HISTORY_TAB, IDCStore, IStoreOrder } from "../../../types/order.types";
import { transformQuantity } from "../../../utils/formatNumber";
import { formatDateTime } from "../../../utils/date-time-format";
import { TableColumn } from "../../Table/CommonTable.types";
import { UnitTab } from "../../../types/data.types";

export const orderHistoryTabs = [
  {
    id: "dc_order_history",
    label: "DC Order History",
    value: HISTORY_TAB.DC_ORDER,
  },
  {
    id: "store_order_history",
    label: "Store Order History",
    value: HISTORY_TAB.STORE_ORDER,
  },
  {
    id: "buyer_comments",
    label: "Buyer Comments",
    value: HISTORY_TAB.BUYER_COMMENTS,
  },
];

export const commonProps = <T extends { isLast?: boolean }>(): Partial<
  TableColumn<T>
> => ({
  getClassName: (row) => (row.isLast ? "font-bold" : ""),
});

export const getDcStoreColumns = (
  selectedUnitTab: UnitTab,
): TableColumn<IDCStore>[] => {
  const unitTabKeys: Record<UnitTab, keyof IDCStore> = {
    0: "orderQuantitySellingUnits",
    1: "orderQuantityShippingUnits",
    2: "orderQuantityVendorUnits",
  };
  const quantityKey =
    unitTabKeys[selectedUnitTab] || "orderQuantitySellingUnits";

  return [
    {
      id: "poNumber",
      label: "PO_NUMBER",
      value: (row) => row.poNumber || "-",
      ...commonProps<IDCStore>(),
      align: "center",
    },
    {
      id: "orderQuantity",
      label: "ORDER_QTY",
      value: (row) =>
        transformQuantity((row[quantityKey] as string | number) || 0) || "",
      ...commonProps<IDCStore>(),
      align: "right",
      type: "number",
    },
    {
      id: "status",
      label: "STATUS",
      value: (row) => {
        if (row.isLast) {
          return "";
        }
        return row.status || "-";
      },
      ...commonProps<IDCStore>(),
      align: "center",
    },
    {
      id: "dcEstimatedArrivalDate",
      label: "DC Est/Arrival Date",
      value: (row) => {
        if (row.isLast) {
          return "";
        }
        return row.dcEstimatedArrivalDate
          ? formatDateTime(row.dcEstimatedArrivalDate.split("T")[0]).date
          : "-";
      },
      ...commonProps<IDCStore>(),
      align: "center",
      type: "date",
    },
  ];
};

export const getStoreOrderColumns = (
  selectedUnitTab: UnitTab,
): TableColumn<IStoreOrder>[] => {
  const unitTabKeys: Record<UnitTab, keyof IStoreOrder> = {
    0: "orderQuantitySellingUnits",
    1: "orderQuantityShippingUnits",
    2: "orderQuantityVendorUnits",
  };
  const quantityKey =
    unitTabKeys[selectedUnitTab] || "orderQuantitySellingUnits";

  return [
    {
      id: "orderNumber",
      label: "ORDER ID",
      value: (row) => row.orderNumber || "-",
      ...commonProps<IStoreOrder>(),
      align: "center",
    },
    {
      id: "orderQuantity",
      label: "QUANTITY",
      value: (row) =>
        transformQuantity((row[quantityKey] as string | number) || 0) || "",
      ...commonProps<IStoreOrder>(),
      align: "right",
      type: "number",
    },
    {
      id: "statusTypeCd",
      label: "STATUS",
      value: (row) => {
        if (row.isLast) {
          return "";
        }
        return row.statusTypeCd || "-";
      },
      ...commonProps<IStoreOrder>(),
      align: "center",
    },
    {
      id: "orderDate",
      label: "ORDER DATE",
      value: (row) => {
        if (row.isLast) {
          return "";
        }
        return row.orderDate
          ? formatDateTime(row.orderDate.split("T")[0]).date
          : "-";
      },
      ...commonProps<IStoreOrder>(),
      align: "center",
      type: "date",
    },
  ];
};
